import { BaseModel } from '@/api/base-model'
import { StatusAPI } from '@/api/backend-client'
import { Company } from '@/api/model/company'

export class Status extends BaseModel<Status> {
    protected collectionName = StatusAPI.collectionName

    constructor(
        public company: Company|null,
        public id: string,
        public status: string,
        public statusReasonRequired: boolean,
        public noReasonEnabled: boolean,
        public createdAt: Date,
        public updatedAt: Date,
    ) { super(id) }

    static fromData(data: any): Status {
        if (data === null || typeof data === 'string' || data instanceof Status) {
            return data
        }

        return new Status(
            data.company ? Company.fromData(data.company) : null,
            data.id,
            data.status,
            data.statusReasonRequired,
            data.noReasonEnabled,
            data.createdAt,
            data.updatedAt,
        )
    }
}
